import React, { useEffect, useRef } from "react";
import { TopBar } from "./components/top-bar";
import { Box } from "@mui/system";
import { Map } from "./components/map";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "./App.css";
import { useDispatch } from "react-redux";
import { resetData } from "./store/app/reducer";
import { MapWfs } from "./components/map/map_landmarks_wfs";

const App = () => {
  const [activeTab, setActiveTab] = useState("SEARCH");
  const firstRef = useRef(null);
  const dispatch = useDispatch();
  const [activeInnerTab, setActiveInnerTab] = useState("CAR"); 
  const [path_datas, setPath_datas] = React.useState([]);

  useEffect(() => {
    if (firstRef.current) {
      dispatch(resetData());
    } else {
      firstRef.current = true;
    }
  }, [activeTab]);
  return (
    <>
      <Box position="relative">
        <TopBar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeInnerTab={activeInnerTab}
          setActiveInnerTab={setActiveInnerTab}
          path_datas={path_datas}
          setPath_datas={setPath_datas}
        />
        <Map
          activeTab={activeTab}
          activeInnerTab={activeInnerTab}
          setActiveInnerTab={setActiveInnerTab}
          path_datas={path_datas}
          setPath_datas={setPath_datas}
        />
        {/* <MapWfs
          activeTab={activeTab}
          activeInnerTab={activeInnerTab}
          setActiveInnerTab={setActiveInnerTab}
          path_datas={path_datas}
          setPath_datas={setPath_datas}
        /> */}
      </Box>
      <ToastContainer />
    </>
  );
};

export default App;
